import { Reference } from '@approvalmax/types';
import { domain } from 'modules/data';

import { messages } from './CustomMonthlyScheduleOption.messages';

export const options: Reference[] = [
    {
        id: domain.MonthlyOption.Day25th,
        text: messages.day25th,
    },
    {
        id: domain.MonthlyOption.MondayOf4thWeek,
        text: messages.mondayOf4thWeek,
    },
    {
        id: domain.MonthlyOption.FridayOf4thWeek,
        text: messages.fridayOf4thWeek,
    },
    {
        id: domain.MonthlyOption.CustomDay,
        text: messages.customDay,
    },
];
